import { Month } from "PFApp/booking/parts/overview/context/use_calendar_days";
import React from "react";

import { useCalendarHeader } from "../use_calendar_header";
import { MonthItem } from "./month_item";
import css from "./months.module.scss";

type MonthsProps = {
  months: Month[];
};

export const Months = ({ months }: MonthsProps): JSX.Element => {
  const { monthsHeight } = useCalendarHeader();

  return (
    <div style={{ height: monthsHeight }} className={css.months}>
      {months.map((month) => (
        <MonthItem key={month.label} month={month} />
      ))}
    </div>
  );
};
